import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
  path?: string;
  seoTitle?: string;
  seoDescription?: string;
}

export function SEOBlock({ appUrl, path = '/gastronomicos', seoTitle, seoDescription }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: seoDescription || 'Proveedor de frutas y verduras para restaurantes, bares y hoteles en Córdoba. Entrega programada, facturación formal y precios mayoristas.',
    url: `${appUrl}${path}`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="gastro-seo">
        <style>{`
          .gastro-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .gastro-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .gastro-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .gastro-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="gastro-seo-inner">
          <h2>{seoTitle || 'Proveedor de frutas y verduras para restaurantes en Córdoba'}</h2>
          <p>
            {seoDescription || 'Abasto Virtual abastece restaurantes, bares y hoteles en Córdoba con frutas y verduras seleccionadas para uso gastronómico profesional, entrega programada y facturación formal.'}
          </p>
        </div>
      </section>
    </>
  );
}
